/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Payments_Search_PlaceholderInputs */

const en_admin_payments_search_placeholder = /** @type {(inputs: Admin_Payments_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search order no or email...`)
};

/**
* | output |
* | --- |
* | "Search order no or email..." |
*
* @param {Admin_Payments_Search_PlaceholderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_payments_search_placeholder = /** @type {((inputs?: Admin_Payments_Search_PlaceholderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Payments_Search_PlaceholderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_payments_search_placeholder(inputs)
});
export { admin_payments_search_placeholder as "admin.payments.search_placeholder" }